<template>
  <div>Выход</div>
</template>

<style lang="scss" scoped>
.kt-spinner.kt-spinner--right:before {
  right: 8px;
}
</style>

<script>
import { LOGOUT } from "@/core/services/store/auth.module";

export default {
  name: "logout",
  beforeMount() {
    this.$store
      .dispatch(LOGOUT)
      .then(() => this.$router.push({ name: "login" }));
  }
};
</script>
